/**
 * @generated SignedSource<<f4ec9c67793c4d3d59059811be361326>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addExtraOptionPanel_ListQuery$variables = Record<PropertyKey, never>;
export type addExtraOptionPanel_ListQuery$data = {
  readonly myAdditionalAttributes: ReadonlyArray<{
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
    readonly products: ReadonlyArray<{
      readonly productID: string;
    } | null> | null;
  }>;
};
export type addExtraOptionPanel_ListQuery = {
  response: addExtraOptionPanel_ListQuery$data;
  variables: addExtraOptionPanel_ListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "status",
        "value": 0
      }
    ],
    "concreteType": "AdditionalAttribute",
    "kind": "LinkedField",
    "name": "myAdditionalAttributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalAttributeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdditionalAttributeProduct",
        "kind": "LinkedField",
        "name": "products",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "myAdditionalAttributes(status:0)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addExtraOptionPanel_ListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addExtraOptionPanel_ListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7232c509a0b6872ce420300b5ef80f4e",
    "id": null,
    "metadata": {},
    "name": "addExtraOptionPanel_ListQuery",
    "operationKind": "query",
    "text": "query addExtraOptionPanel_ListQuery {\n  myAdditionalAttributes(status: 0) {\n    id\n    additionalAttributeID\n    name\n    products {\n      productID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4369495a9701d4636b9a57bf46538550";

export default node;
